/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type TypographyNodeDob_EmbedNode = {
    readonly dateOfBirth?: {
        readonly day: number | null;
        readonly month: number | null;
        readonly year: number | null;
    } | null | undefined;
    readonly " $refType": "TypographyNodeDob_EmbedNode";
};
export type TypographyNodeDob_EmbedNode$data = TypographyNodeDob_EmbedNode;
export type TypographyNodeDob_EmbedNode$key = {
    readonly " $data"?: TypographyNodeDob_EmbedNode$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"TypographyNodeDob_EmbedNode">;
};



const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "day",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "month",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "year",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TypographyNodeDob_EmbedNode",
  "selections": [
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "PatientDateOfBirth",
          "kind": "LinkedField",
          "name": "dateOfBirth",
          "plural": false,
          "selections": (v0/*: any*/),
          "storageKey": null
        }
      ],
      "type": "Patient",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ProviderDateOfBirth",
          "kind": "LinkedField",
          "name": "dateOfBirth",
          "plural": false,
          "selections": (v0/*: any*/),
          "storageKey": null
        }
      ],
      "type": "Provider",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "UserDateOfBirth",
          "kind": "LinkedField",
          "name": "dateOfBirth",
          "plural": false,
          "selections": (v0/*: any*/),
          "storageKey": null
        }
      ],
      "type": "User",
      "abstractKey": null
    }
  ],
  "type": "Node",
  "abstractKey": "__isNode"
};
})();
(node as any).hash = '9edf759e35c68d463f00b1fd44760fdb';
export default node;
